import { Text, Tooltip, TruncateText } from "@instructure/ui";
import { useEffect, useRef, useState } from "react";

export const TruncateToolTip = ({
  children,
  renderTip,
  maxLines,
  placement,
}) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const containerRef = useRef(null);

  const handleUpdate = (truncateState) => {
    if (isTruncated !== truncateState) {
      setIsTruncated(truncateState);
    }
  };

  const renderText = () => {
    return (
      <TruncateText maxLines={maxLines} onUpdate={handleUpdate}>
        {children || ""}
      </TruncateText>
    );
  };

  useEffect(() => {
    if (containerRef.current) {
      // Force a re-render to ensure the container's width is measured correctly
      setIsTruncated(false);
    }
  }, [containerRef.current]);

  return (
    <div ref={containerRef} style={{ width: "100%" }}>
      {isTruncated ? (
        <Tooltip
          color="primary-inverse"
          renderTip={renderTip}
          placement={placement}
        >
          <Text size="small" tabIndex={0}>
            {renderText()}
          </Text>
        </Tooltip>
      ) : (
        renderText()
      )}
    </div>
  );
};
